import { createIcon } from './create-icon'

export const CloseIcon = (): SVGSVGElement => createIcon(['M18 6L6 18', 'M6 6l12 12'])
